import { Component, Inject, Input } from '@angular/core';
import { AppConfig } from '@domgen/dgx-components';
import { CONFIG } from '@domgen/dgx-fe-config';
import { SmartFixBanner } from './smart-fix-banner';
import { NavigationLink } from '@domgen/dgx-fe-common';
import { ManageMyRepairResponse } from '../../../types/manage-my-repair-types';
import { GAService } from '@domgen/dgx-fe-ga';
import { ManageMyRepairService } from '../../../services/manage-my-repair.service';
@Component({
  selector: 'claims-smart-fix-banner',
  templateUrl: './smart-fix-banner.component.html',
  styleUrls: ['./smart-fix-banner.component.scss'],
})
export class SmartFixBannerComponent {
  @Input() smartFixBanner: SmartFixBanner;
  @Input() claims: ManageMyRepairResponse;

  constructor(
    @Inject(CONFIG) private readonly config: AppConfig,
    private readonly GAService: GAService,
    private readonly MMRService: ManageMyRepairService
  ) {}

  get myApplianceUrl() {
    return (
      this.config.smartFixHubUrl +
      '/your-appliance?applianceCode=' +
      this.claims.item.code +
      '&planNumber=' +
      this.claims.planNumber
    );
  }

  get magnoliaSrc() {
    return this.config.magnoliaSrc;
  }

  get smartFixLink(): NavigationLink {
    return {
      newWindow: true,
      href: this.myApplianceUrl,
    };
  }

  sendToGA(): void {
    this.GAService.tag({
      event: 'genericGAEvent',
      clientName: 'DG Claims',
      eventCategory: 'MMR-page',
      eventAction: 'sf-hub-CTA',
      eventLabel: 'Go to Smart-Fix hub',
      pagename: 'claims-manage-my-repairs',
      customerID: this.MMRService?.userData?.sub || '',
      claimedAccountBrand: this.claims?.bookingOEM,
      claimedClientName: this.claims?.bookingOEM,
      claimedManufacturer: this.claims?.item?.manufacturer,
      claimedModelNumber: this.claims?.item?.model_number,
      productName: this.getProductName(),
      companyCode: this.claims?.companyCode,
      countryCode: this.claims?.countryCode,
      planNumber: this.claims?.planNumber,
    });
  }

  getProductName(): string {
    const productName = `${this.claims.item.manufacturer || ''} ${
      this.claims.item.code_description || ''
    }`.toLowerCase();

    return productName;
  }
}
